<div class="animated fadeIn collection">
    <div class="row">
        <div class="col-12 collection-header">
            <button class="btn btn-link" [routerLink]="['/plantingSite', site.id, 'area', this.siteArea.id]">
                <i class="icon-arrow-left"></i>
            </button>
            <h3 class="header-3">{{site.title}} : {{collection.date | date: 'MM/yyyy'}}</h3>
        </div>
        <div class="col-12 collection-detail">
            <h5>{{collection.title}}</h5>
            <p>{{collection.description}} </p>
        </div>
        <div class="collection-info">
            <div class="collection-photos">

                <div class="align-items-center active item carousel-item">
                    <a class="left carousel-control carousel-control-prev" role="button"
                       [routerLink]="['..', activePhoto|previousPhotoId:collection]"
                       [state]="{'skipScroll': true}"
                       [replaceUrl]="true" tabindex="0">
                        <span aria-hidden="true" class="icon-prev carousel-control-prev-icon"></span>
                        <span class="sr-only">Previous</span>
                    </a>

                    <button class="btn btn-dark" (click)="fullImgModal.show()"><i class="icon-magnifier"></i>
                    </button>
                    <span class="location">{{activePhoto.lat | number: '.0-7'}}, {{activePhoto.lon | number: '.0-7'}}</span>
                    <div class="collection-slide-photos white-bg" [appBackgroundUrl]="activePhoto.originalUrl"></div>

                    <a class="right carousel-control carousel-control-next" role="button"
                       [routerLink]="['..', activePhoto|nextPhotoId:collection]"
                       [state]="{'skipScroll': true}"
                       [replaceUrl]="true" tabindex="0">
                        <span aria-hidden="true" class="icon-next carousel-control-next-icon"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
            <div class="col-xs-12 collection-map">
                <button class="btn btn-dark" [routerLink]="['/plantingSite', site.id, collection.id, 'map', activePhoto.id]"><i class="icon-size-fullscreen"></i></button>
                <agm-map [style.height]="'100%'" [style.width]="'100%'"
                         [disableDoubleClickZoom]="true"
                         [streetViewControl]="false"
                         [mapTypeId]="mapTypeId"
                         [maxZoom]="20"
                         [mapTypeControl]='true'
                         [fitBounds]="true"
                         [zoom]="18"
                         >
                    <agm-marker *ngFor="let photo of collection.photos"
                                [agmFitBounds]="true"
                                (markerClick)="navigateToPhoto(photo)"
                                [latitude]="photo.lat"
                                [longitude]="photo.lon"
                                [iconUrl]="photo === activePhoto ? focusedPinUrl : pinUrl"></agm-marker>
                    <agm-kml-layer [url]="siteArea.kmlUrl" [preserveViewport]="map.zoom >=17"></agm-kml-layer>
                    <agm-marker *ngFor="let areaCoordinate of siteArea.kmlAreaProperties" [latitude]="areaCoordinate.latitude" [longitude]="areaCoordinate.longitude"  [label]="{
                        color: 'white',
                        fontFamily: '',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        text: siteArea.year
                    }" [iconUrl]="labelBar" [visible]="map.zoom >=17"></agm-marker>
                </agm-map>
            </div>
        </div>
    </div>
</div>
<app-collection-dialog #fullImgModal></app-collection-dialog>
